<style scoped lang="scss" type="text/scss">
    .funding-container {
        margin: -1rem 0 0 -1rem;
        display: flex;
        flex-wrap: wrap;

        .taobao-account-item {
            margin: 1rem 0 0 1rem;
        }

        .placeholder {
            margin: 1rem 0 0 1rem;
        }
    }
</style>

<template>
    <div class="funding-container">
        <taobao-account-item class="taobao-account-item" v-for="(item, index) in fundingList" :key="index"
                          :info="item" :index="index + 1"
        >
        </taobao-account-item>
        <placeholder v-if="fundingList.length === 0" class="placeholder">
            未填淘宝账号
        </placeholder>
    </div>
</template>

<script>
    import TaobaoAccountItem from '../taobao-account-item';
    import Placeholder from '@/components/placeholder/index';

    export default {
        name: '',
        props: {
            data: {
                type: String,
                default: null
            },
            competitionName: {
                type: String,
                default: null
            }
        },
        components: {
            TaobaoAccountItem,
            Placeholder
        },
        computed: {
            fundingList () {
                if (this.data === null || this.data === undefined || this.data === "") return "";
                return [
                    {
                        name: '淘宝账号',
                        account_value: this.data
                    }
                ];
            }
        },
        data () {
            return {};
        }
    };
</script>
